function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1140px",
    height: "612px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#1b5a46",
    d: "M 763.5,-0.5 C 777.5,-0.5 791.5,-0.5 805.5,-0.5C 875.809,9.00384 929.309,44.0038 966,104.5C 971.822,115.143 976.822,126.143 981,137.5C 1027.2,100.233 1080.03,84.566 1139.5,90.5C 1139.5,264.167 1139.5,437.833 1139.5,611.5C 763.5,611.5 387.5,611.5 11.5,611.5C 4.68613,591.266 0.686131,570.6 -0.5,549.5C -0.5,544.833 -0.5,540.167 -0.5,535.5C 5.6745,451.858 46.0078,391.025 120.5,353C 162.619,334.277 206.286,329.444 251.5,338.5C 238.013,259.462 260.346,192.628 318.5,138C 376.097,90.7447 441.097,76.4114 513.5,95C 541.41,102.951 566.41,116.118 588.5,134.5C 616.585,65.9211 666.585,22.4211 738.5,4C 746.949,2.34581 755.282,0.845812 763.5,-0.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.a1fd060c0c00c96aab4c33a06ec77618.svg";
export { ForwardRef as ReactComponent };